<template>
    <div v-if="isAdmin" id="fichebu-battle-management">
        <as-container gutters="0">
            <div class="grid grid-nogutter mb-3">
                <div class="flex w-100">
                    <as-title :title="$t('ficheBu.battle_list.title')" :size="1"></as-title>
                    <div class="ml-auto">
                        <Button style="width: 200px" :label="$t('ficheBu.battle_list.new_battle_button_label')"
                            class="button-default" @click="showModalBattleForm" />
                    </div>
                </div>
            </div>
            <ProgressBar v-if="isBattleLoading" mode="indeterminate" style="height: 6px" class="mb-3" />
            <battle-list v-else :battles="battles" @onRowClick="editBattle" @onDelete="onShowDeleteBattleModal" />
        </as-container>
    </div>
    <as-modal :isVisible="showBattleForm">
        <battle-form :key="currentBattleKey" :battle="currentBattle" :isSending="isSending"
            @onClose="closeModalBattleForm" @onSubmit="saveBattle" />
    </as-modal>
    <as-confirm-modal :isVisible="showDeleteBattleModal" :modalMessage="$t('confirm_modal.delete_message')"
        @onConfirm="deleteBattle" @onCancel="deleteBattleCancel" />
</template>
<script>
import localeChangeDetectionMixin from "../../mixins/localeChangeDetectionMixins";
import roleMixins from "../../mixins/roleMixins";

import { mapGetters } from "vuex";

import AsTitle from "@/components/Elements/AsTitle.vue";
import AsContainer from "@/components/Containers/AsContainer.vue";
import AsModal from "@/components/Modals/AsModal.vue";
import AsConfirmModal from "@/components/Modals/AsConfirmModal.vue";

import BattleList from "@/components/FicheBu/BattleList.vue";
import BattleForm from "@/components/FicheBu/BattleForm.vue";

import Button from "primevue/button";
import ProgressBar from "primevue/progressbar";

import { getBattles, saveBattle, deleteBattle } from "../../services/battleServiceApi";
import apiEventTypes from "../../constantes/apiEventTypes";

import moment from "moment"

export default {
    name: "BattleManagement",
    components: {
        AsTitle,
        AsContainer,
        AsModal,
        AsConfirmModal,
        BattleList,
        BattleForm,
        Button,
        ProgressBar,
    },
    data() {
        return {
            isBattleLoading: true,
            isSending: false,
            showBattleForm: false,
            currentBattleKey: 0,
            currentBattle: { id: 0, libelle: '', sujets: [{ id: 0, libelle: '' }] },
            battles: [],
            battleToDeleteId: undefined,
            showDeleteBattleModal: false,
        };
    },
    computed: {
        ...mapGetters({
            user: "getUser",
        }),
    },
    mixins: [localeChangeDetectionMixin, roleMixins],
    beforeMount() {
        if (!this.isAdmin) {
            this.$router.push("/")
        } else {
            this.fetchData()
        }
    },
    methods: {
        async fetchData() {
            this._fetchBattles()
        },
        showModalBattleForm() {
            this.currentBattleKey = Math.random();
            this.currentBattle = { id: 0, libelle: '', sujets: [{ id: 0, libelle: '' }] }
            this.showBattleForm = true
        },
        closeModalBattleForm() {
            this.showBattleForm = false
        },
        onShowDeleteBattleModal(battleId) {
            this.battleToDeleteId = battleId;
            this.showDeleteBattleModal = true;
        },
        deleteBattleCancel() {
            this.battleToDeleteId = undefined;
            this.showDeleteBattleModal = false;
        },
        async editBattle(battle) {
            this.currentBattleKey = Math.random();
            this.currentBattle = { ...battle }
            this.showBattleForm = true
        },
        async saveBattle(data) {
            this.isSending = true;
            const payload = JSON.parse(JSON.stringify(data))
            payload.battleHistory.forEach(e => {
                e.date = moment(e.date).format('YYYY-MM')
            })
            const savedBattle = await saveBattle(data)
            this.isSending = false
            if (savedBattle) {
                this.showBattleForm = false
                const battles = [...this.battles]
                const indexOf = battles.findIndex(e => e.id === savedBattle.id)
                savedBattle.battleHistory.forEach(e => { e.battleHistoryItem.sort((a, b) => a.id - b.id) })
                indexOf >= 0 ? battles.splice(indexOf, 1, savedBattle) : battles.push(savedBattle)
                this.battles = battles
                document.dispatchEvent(
                    new CustomEvent(apiEventTypes.API_SUCCESS, {
                        detail: {
                            title: this.$t("popup_messages.success_title"),
                            message: this.$t("popup_messages.success_created_message"),
                        },
                    })
                );
            } else {
                document.dispatchEvent(
                    new CustomEvent(apiEventTypes.API_ERROR, {
                        detail: {
                            title: this.$t("popup_messages.default_error_title"),
                            message: this.$t("popup_messages.default_error_message"),
                        },
                    })
                );
            }
        },
        async deleteBattle() {
            if (!this.battleToDeleteId) { return }
            const result = await deleteBattle(this.battleToDeleteId);
            if (result) {
                const newList = [...this.battles];
                const indexOf = newList.findIndex((e) => e.id === this.battleToDeleteId);
                newList.splice(indexOf, 1);
                this.battles = newList;
                this.deleteBattleCancel()
                document.dispatchEvent(
                    new CustomEvent(apiEventTypes.API_SUCCESS, {
                        detail: {
                            title: this.$t("popup_messages.success_delete_title"),
                            message: this.$t("popup_messages.success_delete_message"),
                        },
                    })
                );
            }
        },
        async _fetchBattles() {
            this.isBattleLoading = true
            this.battles = await getBattles()
            this.isBattleLoading = false
        },
    },
};
</script>

<style lang="scss">
#fichebu-battle-management {
    .p-datatable .p-datatable-tbody>tr>td {
        padding: 0.5rem 1rem !important;
    }
}
</style>
